export default {
  namespaced: true,

  state: () => ({
    permissions: {
      data: [],
      links: {},
      meta: {},
    },
    permission: {},
    isLoading: false,
  }),

  getters: {
    permissionsList: state => {
      const permissions = []
      state.permissions.data.forEach(el => {
        if (el.action === 'manage') {
          permissions.push({
            action: 'manage',
            guard_name: el.guard_name,
            id: el.id,
            name: el.permission,
            permission: el.permission,
          })
        }
      })
      return permissions
    },
  },

  mutations: {
    SET_PERMISSION_LIST(state, payload) {
      state.permissions = payload
    },
    RESET_PERMISSION_LIST(state) {
      state.permissions = {
        data: [],
        links: {},
        meta: {},
      }
    },
    SET_PERMISSION(state, payload) {
      state.permission = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
  },

  actions: {
    // get
    async getPermissionList({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/permissions?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_PERMISSION_LIST', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    // show
    async getPermission({ commit }, { id }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/permissions/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_PERMISSION', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    // delete
    async deletePermission({ commit, dispatch }, { permissionId }) {
      try {
        const url = `/v1/admin/permissions/${permissionId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getPermissionList')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Permission!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Permission!',
        }, { root: true })

        return error
      }
    },
    // create
    async createPermission({ commit }, data) {
      try {
        const url = '/v1/admin/permissions'

        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Permission!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Permission!',
        }, { root: true })

        return error
      }
    },
    // edit
    async updatePermission({ commit }, { permissionId, data }) {
      try {
        const url = `/v1/admin/permissions/${permissionId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Permission!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Permission!',
        }, { root: true })

        return error
      }
    },
  },
}
